import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import InputTextAreaField from '../../components/atoms/input-field/inputTextAreaField';
import MUICustomModal from '../../components/atoms/modal';
import {
  commentGeneralStyle,
  DeletePECRConfirmation,
  VSModalJustification,
} from '../../styles';

//Modal to delete/cancel P/ECR from Tracking page
const DeletePECRPopup = props => {
  const { t } = useTranslation();
  const {
    onBackDropClick = () => {},
    onCommentBackDropClick = () => {},
    onYesClick = () => {},
    onNoClick = () => {},
    onAddCommentClick = () => {},
    onCancelClick = () => {},
    handleCommentChange = () => {},
    openDeletePECRModal = false,
    openAddComment = false,
    deleteCommentValue = '',
    inputValidationMessage = '',
  } = props;

  return (
    <MUICustomModal
      open={openDeletePECRModal}
      modalWidth={400}
      primaryButtonTitle={t('No')}
      secondoryButtonTitle={t('Yes')}
      onSecondoryButtonClick={onYesClick}
      onPrimaryButton={onNoClick}
      onBackDropClick={onBackDropClick}
    >
      <Grid>
        <Grid style={DeletePECRConfirmation}>
          {t('ECR_delete_confirmation')}
        </Grid>
        <AddComment
          openAddComment={openAddComment}
          onAddCommentClick={onAddCommentClick}
          onCancelClick={onCancelClick}
          onCommentBackDropClick={onCommentBackDropClick}
          handleCommentChange={handleCommentChange}
          deleteCommentValue={deleteCommentValue}
          t={t}
          inputValidationMessage={inputValidationMessage}
        />
      </Grid>
    </MUICustomModal>
  );
};

//Modal to get the reason for Cancelling/Deleting the P/ECR
const AddComment = props => {
  const {
    onCommentBackDropClick = () => {},
    onAddCommentClick = () => {},
    onCancelClick = () => {},
    openAddComment,
    handleCommentChange,
    deleteCommentValue,
    t,
    inputValidationMessage = '',
  } = props;

  return (
    <MUICustomModal
      modalWidth={600}
      primaryButtonTitle={t('Close')}
      secondoryButtonTitle={t('Add_Comment')}
      open={openAddComment}
      onSecondoryButtonClick={onAddCommentClick}
      onPrimaryButton={onCancelClick}
      onBackDropClick={onCommentBackDropClick}
      disableSecondoryButton={
        deleteCommentValue === '' || inputValidationMessage !== ''
      }
    >
      <Grid style={VSModalJustification}>
        <InputTextAreaField
          name={'DeleteComment'}
          placeholder={`${t('Provide_Delete_Reason')}...`}
          onChange={handleCommentChange}
          customStyle={commentGeneralStyle}
          value={deleteCommentValue}
          error={inputValidationMessage}
        />
      </Grid>
    </MUICustomModal>
  );
};

export default DeletePECRPopup;
